import React, { Component } from 'react';
import styled from 'styled-components';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';

import { setOverlayValue } from 'store';
import WP from 'WP';
import { currentLanguage } from 'helpers';

import SmartLink from 'partials/SmartLink';
import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Button from 'partials/Button';
import LanguageSwitcher from 'partials/LanguageSwitcher';

import LogoLarge from 'icons/LogoLarge';
import LogoMedium from 'icons/LogoMedium';
import LogoSmall from 'icons/LogoSmall';
import Heart from 'icons/HeartIcon';

import Media, { ScreenWidth } from 'css/Media';

class Menu extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {

        }
    }

    componentWillMount() {
        this.checkScreenSize();
    }

    componentDidMount() {
        if(this.props.size === "s") {
            document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
            window.addEventListener('touchmove',this.preventScroll, { passive: false });
        } else {
            let menu = document.getElementById('menu-wrapper');
            this.props.menuHeight(menu.offsetHeight);
        }
        window.addEventListener('resize', debounce(() => this.checkScreenSize()),500);
    }

    preventScroll(e) {
        return e.preventDefault()
    }

    checkScreenSize() {
        let isMobile = false;

        if(ScreenWidth.lessThan('s')) {
            isMobile = true;
        }

        this.setState({isMobile: isMobile});
    }

    componentWillUnmount() {
        if(this.props.size === "s") {
            document.getElementsByTagName('html')[0].style.overflowY = 'visible';
            window.removeEventListener('touchmove', this.preventScroll);
        }
        window.removeEventListener('resize', this.checkScreenSize());
    } 
  
    render() {
        const { isMobile } = this.state;
        const { menu, onMenuLinkClick, size, primaryMenu } = this.props;
        let cartVisible = this.props.booking.reservations.length ? true : false;

        return (
            <MenuWrapper size={size} id="menu-wrapper">
                <Container grid>
                    <LogoGridElement
                        colStart={1}
                        colEnd={4}
                        colSpan
                    >
                        <NavLink to="/" onClick={() => this.props.toggle()}>
                            { size === 'l' ? 
                                <LogoLarge fill={'#FFFFFF'} /> : 
                            size === 'm' ? 
                                <LogoMedium fill={'#FFFFFF'} /> : 
                                <LogoSmall fill={'#FFFFFF'} /> }
                        </NavLink>
                    </LogoGridElement>
                    <PrimaryMenuGridElement 
                        colStart={{default: 1, s: 6, m: 7}}
                        colEnd={{default: 8, s: 19, m: 18}}
                        rowStart={{default: cartVisible ? 2 : 1, s: 1}}
                    >
                        { primaryMenu && primaryMenu.map((item,idx) => {
                            return (
                                <li key={idx}>
                                    <SmartLink 
                                        onClick={() => this.props.toggle()} 
                                        to={item.url}
                                    >
                                        {item.title}
                                    </SmartLink>
                                </li>
                            )
                        })}
                    </PrimaryMenuGridElement>
                    { !isMobile &&
                        <LanguageSwitcherGridElement
                            colStart={{default: 5, s: 20, m: 20, xl: 23}}
                            colEnd={{default: 8, s: 22, m: 23, xl: 24}}
                            justify={{default: "center", s: "end", xl: "start"}}
                            align="center"
                        >
                            <LanguageSwitcher color={'#FFFFFF'} />
                        </LanguageSwitcherGridElement>
                     }
                    <MainMenuGridElement 
                        colStart={{default: 1, s: 7}}
                        colEnd={{default: 8, s: 15}}
                        rowStart={{default: cartVisible ? 3 : 2, s: 2}}
                        length={menu.length %2 == 0 ? 'even' : 'odd'}>
                        {menu.map(item => {
                            return(
                                <SmartLink 
                                    onClick={() => this.props.toggle()} 
                                    to={item.url} 
                                    key={item.id}
                                >
                                    {item.title}
                                </SmartLink>
                            );
                        })}
                    </MainMenuGridElement>
                    <FavoriteGridElement
                        colStart={{default: 1, s: 7, m: 15}}
                        colEnd={{default: 8, s: 15, m: 18}}
                        rowStart={{default: cartVisible ? 4 : 3, s: 3, m: 'auto'}}
                    >
                        <SmartLink to={currentLanguage() === 'no' ? '/favoritter' : '/favorites'} onClick={() => this.props.toggle()}>
                            <Heart />
                            <span>{WP.trans.myFavorites}</span>
                        </SmartLink>
                    </FavoriteGridElement>
                    { this.props.booking.reservations.length ?
                        <BookingCartGridElement
                            colStart={{default: 1, s: 19}}
                            colEnd={{default: 8, s: 24}}
                            rowStart={{default: 1, s: 2}}
                            justify={{default: 'stretch', s: 'end'}}
                        >
                            <p>{`${currentLanguage() === 'no' ? 'Du har ' : 'You have '}${this.props.booking.reservations.length}${currentLanguage() === 'no' ? ' rom i en pågående booking' : ' rooms in an ongoing booking'}`}</p>
                            <SmartLink to="/checkout" onClick={() => this.props.toggle()}>
                                <StyledButton negative>{WP.trans.bookingCartButton}</StyledButton>
                            </SmartLink>
                        </BookingCartGridElement>
                        : null
                    }
                </Container>
            </MenuWrapper>
        );
    }
}

const mapStateToProps = state => ({
    overlayValue: state.overlayValue,
    booking: state.booking,
})

const actions = {
    setOverlayValue,
}

export default connect(mapStateToProps, actions)(withRouter(Menu));

const MenuWrapper = styled.div`
    background-color: ${props => props.theme.colors.button};
    z-index: 3;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding-top: ${props => props.theme.spacing.elementM};

    ${Media.lessThan('s')`
        overflow-y: auto;
        height: 100vh;
    `}

    .container {
        height: 100%;
        padding-top: 30px;
        
        ${Media.greaterThan('s')`
            padding-top: 50px;
            grid-template-rows: 1fr auto;
        `}

        .lang-switcher {
            padding-bottom: ${props => props.theme.spacing.elementXS};
        }
    }

    ${Media.greaterThan('s')`
        padding-top: 0;
        padding-bottom: ${props => props.theme.spacing.blockXS};
    `}
`

const LogoGridElement = styled(GridElement)`
    position: fixed; 
    top: 30px;
    left: 25px;

    ${Media.greaterThan('s')`
        position: relative; 
        top: 0;
        left: 0;
    `}
`

const PrimaryMenuGridElement = styled(GridElement)`
    li {
        display: block;
        a {
            color: ${props => props.theme.colors.negative};
            font-size: 26px;
            line-height: 42px;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    ${Media.greaterThan('s')`
        align-self: center;
        display: flex;
        justify-content: space-around;
        margin-bottom: ${props => props.theme.spacing.elementXS};

        li {
            display: inline-block;
            
            a {
                font-size: 20px;
            }
        }
    `}
`

const LanguageSwitcherGridElement = styled(GridElement)`
    
    ${Media.greaterThan('s')`
        margin-bottom: ${props => props.theme.spacing.elementXS};
    `}
`

const MainMenuGridElement = styled(GridElement)`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: ${props => props.theme.spacing.contentXS};

    a {
        color: ${props => props.theme.colors.negative};
        width: 100%;
        margin-bottom: ${props => props.theme.spacing.contentS};

        &:hover {
            text-decoration: underline;
        }

        ${Media.greaterThan('s')`
            width: 40%;

            &:last-of-type {
                width: ${props => props.length === 'odd' ? '80%' : '40%'};
                margin-bottom: 0;
            }
        `}
    }

    ${Media.greaterThan('s')`
        justify-content: space-between;
        padding: 0 ${props => props.theme.spacing.contentM};
    `}

    ${Media.greaterThan('m')`
        justify-content: center;
        padding: 0;
    `}
`

const FavoriteGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.blockM};

    a {
        cursor: pointer;
        display: flex;

        svg {
            align-self: center;
            margin-right: ${props => props.theme.spacing.contentXS};
        }

        span {
            color: ${props => props.theme.colors.negative};
        }

        &:hover {
            span {
                text-decoration: underline;
            }
        }
    }

    ${Media.greaterThan('s')`
        padding: 0 ${props => props.theme.spacing.contentM};
    `}

    ${Media.greaterThan('m')`
        padding: 0;
    `}
`

const BookingCartGridElement = styled(GridElement)`
    background: ${props => props.theme.colors.negative};
    border-radius: 10px;
    padding: ${props => props.theme.spacing.contentL};
    margin-bottom: ${props => props.theme.spacing.contentXL};
    text-align: center;

    ${Media.greaterThan('s')`
        margin-bottom: 0;
    `}

    >p {
        padding-bottom: ${props => props.theme.spacing.contentL};
        text-align: left;
    }

    a {
        display: inline-block;
    }
`

const StyledButton = styled(Button)`
    border: 1.5px solid ${props => props.theme.colors.button};

    ${Media.lessThan('s')`
        padding: ${props => props.theme.spacing.contentS} ${props => props.theme.spacing.contentL};
    `}
`